module.exports = "query currentUserOrganizationQuery {\n  currentUser {\n    id\n    organizationId\n  }\n}\n"